<template>
  <DateFilterTab
    v-if="show"

    v-model="bindingValue"
    :tab-buttons="tabButtons"
    :default-actived="defaultActived"

    :hide-date-picker="hideDatePicker"
    :min-date="minDate"
  />
</template>

<script>
import DateFilterTab from '@/components/web/pages/trend/DateFilterTab'
import dayjs from 'dayjs'
import { getLotteryDataDurationMap } from '@/utils/commonLib'

export default {
  name: 'LotteryDateFilterTab', // DateFilterTab 的封裝
  components: {
    DateFilterTab
  },
  props: {
    lotteryCode: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    form: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      tabButtons: [
        { name: '今天', val: dayjs().format('YYYY-MM-DD') },
        { name: '昨天', val: dayjs().subtract(1, 'days').format('YYYY-MM-DD') },
        { name: '近30期', val: '30' },
        { name: '近60期', val: '60' },
        { name: '近90期', val: '90' }
      ],
      defaultActived: '30',
      hideDatePicker: false,
      bindingValue: null,
      minDate: undefined,

      show: false
    }
  },
  watch: {
    bindingValue(bindingValue) {
      const form = {}
      if (/\d{4}-\d{2}-\d{2}/.test(bindingValue)) {
        form.count = undefined
        form.date = bindingValue
        form.year = undefined
      } else if (/^\d{4}$/.test(bindingValue)) {
        form.count = undefined
        form.date = undefined
        form.year = bindingValue
      } else {
        form.count = bindingValue
        form.date = undefined
        form.year = undefined
      }

      this.$emit('updateForm', form)
    },
    '$route': {
      handler: 'initialize',
      immediate: true,
      deep: true
    }
  },
  methods: {
    async initialize() {
      const { lotteryCode = this.$route.params.lottery_code, name = this.$parent.$options.name } = this
      const lotteryMap = getLotteryDataDurationMap(lotteryCode)
      const lotteryType = await this.$getLotteryType(lotteryCode)

      this.minDate = dayjs().subtract(lotteryMap.duration, 'day').format('YYYY-MM-DD')

      if (this.form) {
        if (this.form.date && this.form.count) {
          console.warn('LotteryDateFilterTab: 傳入的form 同時包含了date 和count')
          return
        } else if (this.form.date) {
          this.bindingValue = this.form.date
        } else if (this.form.count) {
          this.bindingValue = this.form.count
        }
        return
      } else {
        this.getDefaultForm({ routerName: name, lotteryCode })
      }

      // 透過component 的名字做些判斷與處理
      switch (name) {
        case 'WebShJh':
        case 'WebBuyPlan':
          this.tabButtons = [{
            name: '近10期',
            val: '10'
          }, {
            name: '近20期',
            val: '20'
          }, {
            name: '近30期',
            val: '30'
          }, {
            name: '近50期',
            val: '50'
          }, {
            name: '近100期',
            val: '100'
          }]
          break
        case 'WebLmTj':
          this.tabButtons = []
          break
        case 'JiShihKaiJiang':
          if (lotteryType === 'others' && this.lotteryCode !== 'shssc') {
            this.tabButtons = [
              { name: '近30期', val: '30' },
              { name: '近60期', val: '60' },
              { name: '今年', val: '2020' },
              { name: '去年', val: '2019' }
            ]
            this.hideDatePicker = true
          }
          break
        default:
        // update tabButtons and hideDataPicker here
      }

      this.show = true
    },
    getDefaultForm({ routerName = undefined, lotteryCode = undefined } = {}) {
      if (routerName === 'WebLmTj') {
        this.bindingValue = dayjs().format('YYYY-MM-DD')
        return
      }
      switch (lotteryCode) {
        // switch-case here
        default:
          this.bindingValue = '30'
      }
    }
  }
}
</script>
